<template>
  <form
    v-if="!showCaptchaError"
    v-show="showForm"
    class="sms-confirm _wide"
    :class="{ '_checkout': isCheckout }"
    @submit.prevent="sendReceivedCodeMethod"
  >
    <div v-if="!isCheckout && $slots.header" class="sms-confirm__header">
      <slot name="header" :close="close"></slot>
    </div>
    <div v-else-if="isCheckout" class="sms-confirm__header">
      <p class="sms-confirm__header-title">
        Введите код подтверждения, отправленный на указанный вами номер
      </p>
    </div>
    <form-item
      class="sms-confirm__form-item sms-confirm__form-input"
      :label="isCheckout ? '' : 'Код подтверждения'"
      :text-after="isCheckout || hideResendBtn ? '' : 'На указанный вами номер отправлен код'"
      is-bold-label
      :text-error="errorSendReceivedCode"
    >
      <input-control
        v-model="value"
        inputmode="numeric"
      />
    </form-item>
    <form-item class="sms-confirm__form-item sms-confirm__form-button">
      <button-control
        :loading="isSendingCode || isFetchingCode"
        :disabled="isDisabledInput"
        is-block
        native-type="submit"
        :is-added-disabled-class-name="isDisabledInput"
        :type="isCheckout ? 'secondary' : 'default'"
      >
        Отправить
      </button-control>

      <button-control
        v-if="isShowBackBtn"
        class="personal-data__user-button"
        native-type="button"
        type="secondary"
        is-block
        :loading="isSendingCode || isFetchingCode"
        :disabled="isSendingCode"
        @click="close"
      >
        Назад
      </button-control>
    </form-item>
    <form-item v-if="!hideResendBtn" class="sms-confirm__form-item">
      <vue-countdown
        v-if="isCounting"
        ref="countdown"
        :time="timeLeft"
        class="sms-confirm__countdown"
        @end="handlerEndCountdown"
      >
        <template slot-scope="props">
          Получить код повторно можно через:
          {{ props.minutes }}
          {{ props.minutes | plural(['минуту', 'минуты', 'минут']) }},
          {{ props.seconds }}
          {{ props.seconds | plural(['секунду', 'секунды', 'секунд']) }},
        </template>
      </vue-countdown>
      <button-control
        v-else-if="timeLeft < 0"
        class="sms-confirm__resend-code"
        type="link-dashed"
        @click="sendCode"
      >
        Получить код повторно
      </button-control>
    </form-item>
    <div v-if="$slots.footer" class="sms-confirm__form-item">
      <slot name="footer"></slot>
    </div>
  </form>
  <notification v-else type="error" class="sms-confirm__notification">
    {{ captchaErrorText }}
  </notification>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';
import {
  InputControl, FormItem, ButtonControl, Notification,
} from '@book24/ui-components';
import useSmsConfirm from '@/js/vue/_composition/auth/useSmsConfirm';

export default {
  name: 'SmsConfirm',
  components: {
    InputControl,
    FormItem,
    ButtonControl,
    Notification,
    VueCountdown,
  },
  props: {
    phone: {
      default: '',
      type: String,
      required: true,
    },
    isUseNewEndPoint: {
      type: Boolean,
      default: false,
    },
    isShowBackBtn: {
      type: Boolean,
      default: false,
    },
    captchaOptions: {
      type: Object,
      default: () => {},
    },
    captchaOptionsV2: {
      type: Object,
      default: () => {},
    },
    isCheckout: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const smsConfirm = useSmsConfirm(props, context);

    const close = () => {
      context.emit('close');
    };

    return {
      ...smsConfirm,
      close,
    };
  },
};
</script>
